
import React, { useState, useEffect } from 'react';
import { Timer, Zap, ArrowRight, Sparkles } from 'lucide-react';
import { FlashSale } from '../types';

interface Props {
  sale: FlashSale;
}

const FlashSaleBanner: React.FC<Props> = ({ sale }) => {
  const [timeLeft, setTimeLeft] = useState<{h:number, m:number, s:number}>({h:0, m:0, s:0});

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const end = new Date(sale.endTime).getTime();
      const diff = end - now;

      if (diff <= 0) {
        clearInterval(timer);
        window.location.reload();
        return;
      }

      setTimeLeft({
        h: Math.floor((diff / (1000 * 60 * 60)) % 24),
        m: Math.floor((diff / 1000 / 60) % 60),
        s: Math.floor((diff / 1000) % 60)
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [sale.endTime]);

  return (
    <div className="bg-gradient-to-r from-orange-600 via-red-600 to-purple-700 py-4 relative overflow-hidden group">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-10"></div>
      <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-6 relative z-10">
        <div className="flex items-center gap-4">
           <div className="w-12 h-12 bg-white/20 backdrop-blur-xl rounded-2xl flex items-center justify-center text-white animate-pulse">
              <Zap className="h-6 w-6 fill-current" />
           </div>
           <div>
              <h3 className="text-white font-black text-xl tracking-tight uppercase italic">{sale.name}</h3>
              <p className="text-orange-200 text-[10px] font-bold uppercase tracking-[0.2em] flex items-center gap-2">
                 <Sparkles className="h-3 w-3" /> Get <span className="text-white underline">{sale.discountPercentage}% Instant OFF</span> on select tech
              </p>
           </div>
        </div>

        <div className="flex items-center gap-6">
           <div className="flex gap-2">
              {[
                { val: timeLeft.h, label: 'HRS' },
                { val: timeLeft.m, label: 'MIN' },
                { val: timeLeft.s, label: 'SEC' }
              ].map((unit, i) => (
                <div key={i} className="flex flex-col items-center">
                   <div className="bg-white/10 backdrop-blur-md border border-white/20 w-14 h-14 rounded-2xl flex items-center justify-center text-white text-2xl font-black shadow-2xl">
                      {unit.val.toString().padStart(2, '0')}
                   </div>
                   <span className="text-[8px] text-white/60 font-black mt-1 uppercase tracking-widest">{unit.label}</span>
                </div>
              ))}
           </div>
           <button className="bg-white text-red-600 px-8 py-4 rounded-2xl font-black text-sm uppercase tracking-widest shadow-2xl hover:scale-105 active:scale-95 transition-all flex items-center gap-2">
              Claim Deals <ArrowRight className="h-4 w-4" />
           </button>
        </div>
      </div>
    </div>
  );
};

export default FlashSaleBanner;
